import type {
    StoreState,
    SurveyState,
    UiCoreQuestionFormState,
    UiState,
} from './state-types';

export const defaultSurveyState: SurveyState = {
    id: '',
    qqid: '',
    name: '',
    cardIds: [],
    traxexLabel: '',
    aboutCopy: '',
    sponsorInfo: undefined,
    liveProofUrl: null,
    theme: {
        primaryColor: '#1665cf',
        backgroundColor: '#ffffff',
        answerStyle: 'solid',
    },
    placement: {
        placementType: 'gam',
    },
    publicationStatus: 'unpublished',
};

export const defaultUiState: UiState = {
    isSurveyDirty: false,
    previousSurveyName: '',
    previewShortcut: false,
    publishShortcut: false,
    status: 'idle',
    showChangelog: false,
};

export const defaultUiCoreQuestionFormState: UiCoreQuestionFormState = {
    isDirty: false,
    isActive: false,
};

export const defaultStoreState: Omit<StoreState, 'actions'> = {
    survey: defaultSurveyState,
    cards: {},
    answers: {},
    coreQuestions: {},
    ui: defaultUiState,
    uiCoreQuestionForm: defaultUiCoreQuestionFormState,
};
